// 获取状态信息
export const resturantId = state => state.resturantId
export const resturantName = state => state.resturantName
export const statisticalDate = state => state.statisticalDate



// WEBPACK FOOTER //
// ./src/store/getters.js